__turbopack_context__.v({
  "account-link": "_5Hk6NG_account-link",
  "contact-link": "_5Hk6NG_contact-link",
  "header": "_5Hk6NG_header",
  "home-link": "_5Hk6NG_home-link",
  "logo": "_5Hk6NG_logo",
  "nav": "_5Hk6NG_nav",
  "placeholder": "_5Hk6NG_placeholder",
  "search-link": "_5Hk6NG_search-link",
});
